export default __webpack_public_path__ + "static/media/meetings_n.69a78e58.svg";